export default __webpack_public_path__ + "static/media/Webpack-icon.3b7bf087.png";